export default "__VITE_ASSET__DdpX4GGO__"